import { render } from "./StripeDash.vue?vue&type=template&id=523f34a2&scoped=true"
import script from "./StripeDash.vue?vue&type=script&lang=js"
export * from "./StripeDash.vue?vue&type=script&lang=js"

import "./StripeDash.vue?vue&type=style&index=0&id=523f34a2&lang=scss&scoped=true"

import exportComponent from "/home/scotty/git/beamy/monolith/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-523f34a2"]])

export default __exports__